import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

const FormSchema = z.object({
  name: z.string().min(1, { message: "Campo obrigatório" }),
  with_diet: z.boolean().default(false),
  description: z.string().min(1, { message: "Campo obrigatório" }),
});
export type FormSchemaType = z.infer<typeof FormSchema>;

type Props = {
  isOpen: boolean;
  initialValues?: FormSchemaType;
  onClose: () => void;
  onSubmit: (values: FormSchemaType) => void;
};

const UserGroupForm: React.FC<Props> = ({
  isOpen,
  initialValues,
  onClose,
  onSubmit,
}) => {
  const form = useForm<FormSchemaType>({
    resolver: zodResolver(FormSchema),
    values: { name: "", description: "", with_diet: false },
  });

  useEffect(() => {
    console.log(initialValues);
    form.reset(initialValues);
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] bg-white">
        <DialogHeader className="border-b-[1px] border-black pb-2">
          <DialogTitle>
            {initialValues ? "Atualizar grupo" : "Novo grupo"}
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4">
              <div className="grid gap-3">
                <FormField
                  name="name"
                  control={form.control}
                  render={({ field }) => (
                    <FormItem className="">
                      <FormLabel className="text-gray-600">Nome</FormLabel>

                      <FormControl>
                        <Input
                          className="bg-gray-100 text-gray-600"
                          {...field}
                        />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <FormField
                name="description"
                control={form.control}
                render={({ field }) => (
                  <FormItem>
                    <FormLabel className="text-gray-600">Descrição</FormLabel>

                    <FormControl>
                      <Input
                        className="bg-gray-100 text-gray-600 "
                        {...field}
                      />
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                name="with_diet"
                control={form.control}
                render={({ field }) => (
                  <FormItem className="flex items-center gap-2 hover:opacity-80 transition-all duration-300">
                    <FormControl>
                      <Input
                        type="checkbox"
                        checked={field.value}
                        onChange={field.onChange}
                        className="bg-gray-100 text-gray-600 h-4 w-4 !m-0 !cursor-pointer"
                      />
                    </FormControl>
                    <FormLabel className="text-gray-600 h-4 !m-0 !cursor-pointer">Com dieta</FormLabel>
                  </FormItem>
                )}
              />
            </div>
            <DialogFooter className="mt-6">
              <Button variant="outline" onClick={onClose} type="button">
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default UserGroupForm;
